var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdialogueIconBlank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34.798mm",
    height: "28.915mm",
    viewBox: "0 0 34.798 28.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "expanded",
    fill: "#f60",
    style: {
      mixBlendMode: "normal"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0031204,
    width: 30.148,
    height: 25.94,
    strokeWidth: 0.26482
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.619 25.869 12.179 3.0448-4.6541-5.9591z",
    strokeWidth: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdialogueIconBlank);
export default __webpack_public_path__ + "static/media/idialogue-icon-blank.7d98fd372ddfcdf43d024ba254351bae.svg";
export { ForwardRef as ReactComponent };